import {
  defineInfrastructureHTMLPointsLayer,
  defineInfrastructurePointsLayer,
  defineBalloonManager,
  defineDrawPolygon,
  defineHotspotsLayer,
  definePointsLayer,
  defineFrecklesPointsLayer,
} from './ymapsModules';

export async function loadYMapsApi(modules?: string[]): Promise<YMaps.IYMaps> {
  return new Promise((resolve, reject) => {
    window.ymapsLoaded(ymaps => {
      definePointsLayer(ymaps);
      defineInfrastructurePointsLayer(ymaps);
      defineInfrastructureHTMLPointsLayer(ymaps);
      defineBalloonManager(ymaps);
      defineDrawPolygon(ymaps);
      defineHotspotsLayer(ymaps);
      defineFrecklesPointsLayer(ymaps);

      ymaps.ready({
        require: modules,
        successCallback: ymaps => resolve(ymaps),
        errorCallback: error => reject(error),
      });
    });
  });
}
